import { Controller } from "@hotwired/stimulus"

/**
 * Checkbox Button Controller with Dynamic Label
 *
 * Enables/disables button based on checkbox selection and updates button label
 * to show the count of selected items.
 *
 * @example
 * <div data-controller="checkbox-button"
 *      data-checkbox-button-label-value="Delete items">
 *   <input type="checkbox"
 *          data-checkbox-button-label-target="checkbox"
 *          data-action="change->checkbox-button-label#update">
 *   <input type="checkbox"
 *          data-checkbox-button-label-target="checkbox"
 *          data-action="change->checkbox-button-label#update">
 *   <button data-checkbox-button-label-target="button">
 *     <span>Delete items</span>
 *   </button>
 * </div>
 *
 * Results in:
 * - 0 selected: <span>Delete items</span> (disabled)
 * - 1+ selected: <span>Delete items</span><span class='button-secondary--badge'>1</span> (enabled)
 */

export default class extends Controller {
  static targets = ["checkbox", "button"]
  static values = {
    label: { type: String, default: "Submit" },
  }

  connect() {
    this.update()
  }

  update() {
    const checkedCount = this.checkboxTargets.filter(checkbox => checkbox.checked).length
    const anyChecked = checkedCount > 0

    this.buttonTargets.forEach(button => {
      button.disabled = !anyChecked

      // Update button label
      button.innerHTML = this.#labelText(checkedCount)
    })
  }

  #labelText(count) {
    if (count === 0) {
      return `<span>${this.labelValue}</span>`
    } else {
      return `<span>${this.labelValue}</span><span class="button-secondary--badge">${count}</span>`
    }
  }
}
